"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Five9AgentChatService = void 0;
class Five9AgentChatService {
    constructor() {
        this.initialized = false;
        this.agentChatFrameId = 'five9-frame-full';
        this.openAgentChatButtonId = 'five9-maximize-button';
        this.agentChatPillClass = 'five9-frame';
        this.activeChatIndicatorClass = 'active-chat';
        this.chatIFrameId = 'embedded-frame';
        this.observerOptions = { attributes: false, childList: true, characterData: false, subtree: true };
    }
    init() {
        if (this.initialized) {
            return;
        }
        //Check if five9 script has run
        const five9Frame = document.getElementsByClassName(this.agentChatPillClass);
        if ((five9Frame === null || five9Frame === void 0 ? void 0 : five9Frame.length) > 0) {
            //Since five9 script has run, check for existing iframe in case of refresh
            const chatIFrame = document.getElementById(this.chatIFrameId);
            this.adjustAgentChatPillClassList(!!chatIFrame);
            //Create observer that watches for iframe add/removal
            this.agentChatObserver = this.createFive9ChatMutationObserver();
        }
        else {
            //Create observer that watches for Five9 script to run
            this.bodyObserver = this.createFive9WidgetMutationObserver();
        }
        this.initialized = true;
    }
    openAgentChatWindow() {
        var _a, _b, _c, _d;
        this.init();
        if (!document.getElementById(this.openAgentChatButtonId)) {
            window.ESFive9((_c = (_b = (_a = window.ES_PATIENT_HUB) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.instance) === null || _c === void 0 ? void 0 : _c.five9Tenant);
        }
        (_d = document.getElementById(this.openAgentChatButtonId)) === null || _d === void 0 ? void 0 : _d.click();
        this.enableChatPill();
    }
    agentChatChanges(mutations) {
        mutations.forEach((mutation) => {
            var _a, _b;
            if (((_a = mutation.addedNodes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.enableChatPill();
            }
            else if (((_b = mutation.removedNodes) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                this.disableChatPill();
            }
        });
    }
    widgetChatChanges(mutations) {
        mutations.forEach((mutation) => {
            if (!mutation.addedNodes) {
                return;
            }
            mutation.addedNodes.forEach((node) => {
                var _a, _b, _c;
                if ((_b = (_a = node) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains(this.agentChatPillClass)) {
                    this.createFive9ChatMutationObserver();
                    (_c = this.bodyObserver) === null || _c === void 0 ? void 0 : _c.disconnect();
                }
            });
        });
    }
    enableChatPill() {
        this.adjustAgentChatPillClassList(true);
    }
    disableChatPill() {
        this.adjustAgentChatPillClassList(false);
    }
    createFive9WidgetMutationObserver() {
        let observer = new MutationObserver((mutations) => {
            this.widgetChatChanges(mutations);
        });
        observer.observe(document.body, this.observerOptions);
        return observer;
    }
    createFive9ChatMutationObserver() {
        let observer = new MutationObserver((mutations) => {
            this.agentChatChanges(mutations);
        });
        const agentFrame = document.getElementById(this.agentChatFrameId);
        if (agentFrame) {
            observer.observe(agentFrame, this.observerOptions);
        }
        return observer;
    }
    adjustAgentChatPillClassList(addClass) {
        var _a, _b;
        const agentChatPillFrame = document.getElementsByClassName(this.agentChatPillClass);
        if (addClass) {
            (_a = agentChatPillFrame[0]) === null || _a === void 0 ? void 0 : _a.classList.add(this.activeChatIndicatorClass);
        }
        else {
            (_b = agentChatPillFrame[0]) === null || _b === void 0 ? void 0 : _b.classList.remove(this.activeChatIndicatorClass);
        }
    }
    disconnect() {
        var _a, _b;
        (_a = this.agentChatObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.bodyObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
    /**
     * For more information see
     * {@link https://exas.atlassian.net/wiki/spaces/PHUB0/pages/2999617540/270516+Add+existing+Five9+chat+functionality}
     * @param five9Config
     */
    static initializeFive9Scripts(five9Config) {
        if (!five9Config || !five9Config.widgetUrl || !five9Config.widgetConfig) {
            throw new Error("Missing Five9 configuration to initialize chat widget");
        }
        let five9ScriptElement = document.createElement("script");
        five9ScriptElement.id = "five9";
        five9ScriptElement.type = "text/javascript";
        five9ScriptElement.src = five9Config.widgetUrl;
        five9ScriptElement.async = false;
        five9ScriptElement.addEventListener("load", () => {
            Five9SocialWidget.addWidget(five9Config.widgetConfig);
        });
        document.body.appendChild(five9ScriptElement);
    }
}
exports.Five9AgentChatService = Five9AgentChatService;
//# sourceMappingURL=five9-agent-chat.service.js.map